"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSCRouterSettingsT = exports.OSCRouterSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const oscsettings_js_1 = require("../../solarxr-protocol/rpc/oscsettings.js");
/**
 * OSC router forwards messages it receives, to allow the usage of multiple OSC programs for the same app.
 */
class OSCRouterSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsOSCRouterSettings(bb, obj) {
        return (obj || new OSCRouterSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsOSCRouterSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new OSCRouterSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    oscSettings(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new oscsettings_js_1.OSCSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startOSCRouterSettings(builder) {
        builder.startObject(1);
    }
    static addOscSettings(builder, oscSettingsOffset) {
        builder.addFieldOffset(0, oscSettingsOffset, 0);
    }
    static endOSCRouterSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createOSCRouterSettings(builder, oscSettingsOffset) {
        OSCRouterSettings.startOSCRouterSettings(builder);
        OSCRouterSettings.addOscSettings(builder, oscSettingsOffset);
        return OSCRouterSettings.endOSCRouterSettings(builder);
    }
    unpack() {
        return new OSCRouterSettingsT((this.oscSettings() !== null ? this.oscSettings().unpack() : null));
    }
    unpackTo(_o) {
        _o.oscSettings = (this.oscSettings() !== null ? this.oscSettings().unpack() : null);
    }
}
exports.OSCRouterSettings = OSCRouterSettings;
class OSCRouterSettingsT {
    constructor(oscSettings = null) {
        this.oscSettings = oscSettings;
    }
    pack(builder) {
        const oscSettings = (this.oscSettings !== null ? this.oscSettings.pack(builder) : 0);
        return OSCRouterSettings.createOSCRouterSettings(builder, oscSettings);
    }
}
exports.OSCRouterSettingsT = OSCRouterSettingsT;
